import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getKpiScoreSize, getVersionScoreDistribution } from '../../features/HealthScore/HealthScoreAction';
import usePackageSelection from '../../modules/Accounts/components/PackageSelection/usePackageSelection';
import useToggle from '../../hooks/useToggle';

const useScoreInsights = () => {
  const dispatch = useDispatch();
  const { packageList } = usePackageSelection();

  const [selectedPackage, setSelectedPackage] = useState('');
  const [refreshKpiScoreSize, setRefreshKpiScoreSize] = useToggle();
  const [refreshVersionScore, setRefreshVersionScore] = useToggle();

  useEffect(() => {
    dispatch(getKpiScoreSize());
  }, [refreshKpiScoreSize]);

  useEffect(() => {
    if (packageList?.packages?.[0]?.packageId) {
      setSelectedPackage(packageList.packages[0].packageId);
    }
  }, [packageList]);

  useEffect(() => {
    if (selectedPackage) {
      dispatch(getVersionScoreDistribution({ packageId: selectedPackage }));
    }
  }, [refreshVersionScore, selectedPackage]);

  const handlePackageChange = (e) => {
    setSelectedPackage(e.target.value);
  };

  const packageListData = useMemo(() => {
    return packageList?.packages?.map((item) => ({
      id: item.packageId,
      name: item.packageLabel,
      value: item.packageId,
    }));
  }, [packageList]);

  const kpiScoreSize = useSelector((state) => state.kpiScoreSize);
  const versionScoreDist = useSelector((state) => state.versionScoreDistribution);

  return {
    kpiScoreSize,
    versionScoreDist,
    setRefreshKpiScoreSize,
    setRefreshVersionScore,
    packageListData,
    selectedPackage,
    handlePackageChange,
  };
};

export default useScoreInsights;
